import * as React from "react";
import type { SVGProps } from "react";
const SvgMountainsDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#mountains-down_svg__a)">
      <path d="M12 18a1 1 0 0 1-1-1v-6a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1" />
      <path d="M12 18a1 1 0 0 1-.71-.29l-2.5-2.5a1.004 1.004 0 0 1 1.42-1.42l1.79 1.8 1.79-1.8a1.004 1.004 0 1 1 1.42 1.42l-2.5 2.5A1 1 0 0 1 12 18" />
      <path d="M21 21H3a1 1 0 0 1-.93-1.37L6.69 8a2.38 2.38 0 0 1 2.05-1.53A2.2 2.2 0 0 1 10.2 7l1.22-2.54A2.42 2.42 0 0 1 13.55 3a2.36 2.36 0 0 1 2.1 1.5l6.27 15.12a1 1 0 0 1-.09.94A1 1 0 0 1 21 21M4.47 19h15L13.82 5.28c-.09-.2-.22-.28-.3-.28-.1 0-.21.11-.29.28l-2 4.07a1 1 0 0 1-.88.56 1 1 0 0 1-.9-.52l-.38-.68c-.08-.15-.21-.25-.27-.24s-.21.09-.31.31z" />
    </g>
    <defs>
      <clipPath id="mountains-down_svg__a">
        <path fill="#fff" d="M2 3h20v18H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMountainsDown;
